/** Slot names in order. areas[] must only use names from this list. */
export const SLOT_NAMES = ['m', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h'];
export const LAYOUTS = {
    '1': {
        id: '1',
        label: 'Einzel',
        slots: 1,
        columns: '1fr',
        rows: '1fr',
        areas: ['m'],
        fullQuality: ['m'],
    },
    pip: {
        id: 'pip',
        label: 'Bild im Bild',
        // One angle full screen, a second one small in a corner. On a desktop the
        // small one can be dragged anywhere.
        slots: 2,
        columns: '1fr',
        rows: '1fr',
        areas: ['m'],
        fullQuality: ['m'],
        pip: true,
    },
    '2x1': {
        id: '2x1',
        label: 'Zwei gleich',
        // Two matches at once rather than one match from two angles: neither side
        // is "the main one", so neither gets more pixels -- nor a worse rendition.
        slots: 2,
        columns: '1fr 1fr',
        rows: '1fr',
        areas: ['m a'],
        fullQuality: ['m', 'a'],
        resizable: true,
    },
    '1+2': {
        id: '1+2',
        label: 'Haupt + 2',
        slots: 3,
        columns: '2fr 2fr 1fr',
        rows: '1fr 1fr',
        areas: ['m m a', 'm m b'],
        fullQuality: ['m'],
    },
    '1+3': {
        id: '1+3',
        label: 'Haupt + 3',
        slots: 4,
        columns: '3fr 3fr 3fr 1fr',
        rows: '1fr 1fr 1fr',
        areas: ['m m m a', 'm m m b', 'm m m c'],
        fullQuality: ['m'],
    },
    '2x2': {
        id: '2x2',
        label: 'Vierer',
        slots: 4,
        columns: '1fr 1fr',
        rows: '1fr 1fr',
        areas: ['m a', 'b c'],
        fullQuality: ['m', 'a', 'b', 'c'],
    },
    '1+4': {
        id: '1+4',
        label: 'Haupt + 4',
        slots: 5,
        columns: '3fr 3fr 3fr 1fr',
        rows: '1fr 1fr 1fr 1fr',
        areas: ['m m m a', 'm m m b', 'm m m c', 'm m m d'],
        fullQuality: ['m'],
    },
    '2+4': {
        id: '2+4',
        label: 'Zwei + 4',
        // Two matches side by side with four extra angles underneath.
        slots: 6,
        columns: '1fr 1fr 1fr 1fr',
        rows: '2fr 1fr',
        areas: ['m m a a', 'b c d e'],
        fullQuality: ['m', 'a'],
    },
    '1+5': {
        id: '1+5',
        label: 'Haupt + 5',
        slots: 6,
        columns: '1fr 1fr 1fr',
        rows: '1fr 1fr 1fr',
        areas: ['m m a', 'm m b', 'c d e'],
        fullQuality: ['m'],
    },
    '3x3': {
        id: '3x3',
        label: 'Neuner',
        slots: 9,
        columns: '1fr 1fr 1fr',
        rows: '1fr 1fr 1fr',
        areas: ['m a b', 'c d e', 'f g h'],
        fullQuality: ['m'],
    },
    'focus+strip': {
        id: 'focus+strip',
        label: 'Haupt + Streifen',
        slots: 5,
        columns: '1fr 1fr 1fr 1fr',
        rows: '1fr 0.26fr',
        areas: ['m m m m', 'a b c d'],
        fullQuality: ['m'],
    },
};
/** Cycle order for the up/down remote keys: fewest tiles first, so stepping
 *  through it never jumps from one stream to nine. */
export const LAYOUT_CYCLE = [
    '1', 'pip', '2x1', '1+2', '1+3', '2x2', '1+4', 'focus+strip', '1+5', '2+4', '3x3',
];
export function slotsFor(layout) {
    return SLOT_NAMES.slice(0, LAYOUTS[layout].slots);
}
/**
 * Decoder budget, not screen real estate, is the binding constraint. A TV box
 * typically has one or two hardware 1080p decoders; anything beyond that falls
 * back to software. Secondary tiles are downscaled by the proxy to keep that
 * software path cheap, but there is still a ceiling.
 */
export const MAX_TILES = { tv: 4, desktop: 9, mobile: 4 };
/**
 * Full-quality renditions decoded at once. The same decoder argument: a TV box
 * holds two 1080p streams in hardware, a desktop comfortably four.
 */
export const MAX_FULL_QUALITY = { tv: 2, desktop: 4, mobile: 2 };
/** Layouts that fit a platform's tile ceiling. */
export function layoutsFor(platform) {
    return LAYOUT_CYCLE.filter((id) => LAYOUTS[id].slots <= MAX_TILES[platform]);
}
//# sourceMappingURL=layouts.js.map